import { ViewportType } from '../../../enums/index.js';
import { getECGProjectionPresentation, withECGProjectionPresentation, } from './ecgProjectionPresentation.js';
import { getECGProjectionSnapshot } from './ecgProjectionSnapshot.js';
import { ECG_PROJECTION_ID, } from './ECGProjectionTypes.js';
export { getECGProjectionSnapshot };
export const ecgProjectionAdapter = {
    id: ECG_PROJECTION_ID,
    viewportTypes: [ViewportType.ECG_NEXT],
    getSnapshot: (request) => getECGProjectionSnapshot(request),
    getPresentation: (snapshot, selector) => getECGProjectionPresentation(snapshot, selector),
    withPresentation: (snapshot, presentation, options) => withECGProjectionPresentation(snapshot, presentation, options),
};
